import { ElementRef, NgModule } from '@angular/core';
//import { AngularApp } from './serverTypes/yeshivaTypes';

@NgModule()
export class AppUtilsModule {
    static deepCopyObj(oldObj: any) {
        let newObj: typeof oldObj; //not affective during runtime
        newObj = JSON.parse(JSON.stringify(oldObj));
        //... so use this magic:
        newObj.__proto__ = oldObj.__proto__;
        return newObj;
    }

    static deepCopy(obj: { [key: string]: any }): any {
        var copy: any;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = this.deepCopy(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    static createHost(protocol: string, domain: string, port: string): string {
        let host = '';

        if (domain !== '') {
            //protocol
            if (protocol.includes('//')) {
                host = protocol;
            } else if (protocol === '') {
                host = '//';
            } else {
                host = protocol + '://';
            }

            //domain
            host += domain;
        }

        if (port.includes(':')) {
            host += port;
        } else if (port !== '') {
            host += ':' + port;
        }

        //empty port
        return host;
    }

    static updateInput(value: any, inputName: string, elRef: ElementRef) {
        if (elRef.nativeElement[inputName.toLowerCase()]) {
            if (value) {
                elRef.nativeElement.setAttribute(inputName.toLowerCase(), value);
            } else {
                elRef.nativeElement.removeAttribute(inputName.toLowerCase());
            }
        } else {
            if (value) {
                elRef.nativeElement.setAttribute(inputName, value);
            } else {
                elRef.nativeElement.removeAttribute(inputName);
            }
        }
    }
}
